const translations = {
  en: {
    // Navigation
    leadersView: "Leader's View",
    home: "Home",
    summary: "Summary",

    // Main page
    readyForQuiz: "Let’s begin. Just a few quick questions.", 
    yesOfCourse: "Click here to start!",
    maybeNextTime: "Maybe next time?",

    // Form labels
    aboutYou: "About you",
    name: "Name",
    email: "Email",
    departments: "Departments",
    ageGroups: "Age Groups",
    gender: "Gender",
    none: "None",

    // Form validation messages
    nameLengthError: "Name must be longer than 2 characters",
    invalidEmailError: "Invalid email id",
    alreadySubmitted: "Answers are already submitted from this email ID!",

    // Question page
    submit: "SUBMIT",
    next: "NEXT",
    loading: "Loading...",
    leaveConfirmation: "Data will be lost if you leave the page, are you sure?",

    // Result page
    thankYou: "Thank you",
    forYourTime: "for your time!",
    veryHappyMessage: "You are happy! Just keep it up :)",
    lessHappyMessage: "You are just few points behind to be happy :)",
    backToHome: "Back to home",
    happyWithResult: "Are you satisfied with our result?",
    yes: "Yes",
    no: "No",
    feedbackThanks: "Thank you for your feedback!",

    // Next time page
    seeYouSoon: "See you soon!",

    // Error messages
    somethingWentWrong: "Something went wrong! Please go to",
    adminOnlyView: "This view is only for admins. Please login or go back to",
    networkError:
      "It seems to be a network error. We'll come back soon! Go back to",

    // Chart view
    overall: "Overall",
    departments: "Departments",
    ageGroups: "Age Groups",
    gender: "Gender",
    presentation: "Presentation",
    chartType: "Chart Type",
    groups: "Groups",
  },
  hi: {
    // Navigation
    leadersView: "अध्यक्ष के लिये",
    home: "होम",
    summary: "सारांश",

    // Main page
    readyForQuiz: "क्या आप प्रश्नो के उत्तर देने के लिये तैयार हैं ?",
    yesOfCourse: "हां, बिलकुल!",
    maybeNextTime: "शायद अगली बार?",

    // Form labels
    aboutYou: "आपके बारे में",
    name: "नाम",
    email: "ईमेल",
    departments: "विभाग",
    ageGroups: "आयु समूह",
    gender: "लिंग",
    none: "कोई नहीं",

    // Form validation messages
    nameLengthError: "नाम 2 अक्षरों से अधिक होना चाहिए",
    invalidEmailError: "अमान्य ईमेल आईडी",
    alreadySubmitted: "इस ईमेल आईडी से उत्तर पहले ही जमा किए जा चुके हैं!",

    // Question page
    submit: "जमा करें",
    next: "अगला",
    loading: "लोड हो रहा है...",
    leaveConfirmation:
      "यदि आप पेज छोड़ते हैं तो डेटा खो जाएगा, क्या आप सुनिश्चित हैं?",

    // Result page
    thankYou: "धन्यवाद",
    forYourTime: "आपके समय के लिए!",
    veryHappyMessage: "आप खुश हैं! बस ऐसे ही बने रहें :)",
    lessHappyMessage: "आप खुश होने के लिए बस कुछ ही अंक पीछे हैं :)",
    backToHome: "होम पर वापस जाएं",
    happyWithResult: "क्या आप हमारे परिणाम से संतुष्ट हैं?",
    yes: "हां",
    no: "नहीं",
    feedbackThanks: "आपकी प्रतिक्रिया के लिए धन्यवाद!",

    // Next time page
    seeYouSoon: "जल्द ही फिर मिलेंगे!",

    // Error messages
    somethingWentWrong: "कुछ गलत हो गया! कृपया यहां जाएं",
    adminOnlyView:
      "यह दृश्य केवल व्यवस्थापकों के लिए है। कृपया लॉगिन करें या वापस जाएं",
    networkError:
      "ऐसा लगता है कि नेटवर्क त्रुटि है। हम जल्द ही वापस आएंगे! वापस जाएं",

    // Chart view
    overall: "समग्र",
    departments: "विभाग",
    ageGroups: "आयु समूह",
    gender: "लिंग",
    presentation: "प्रस्तुति",
    chartType: "चार्ट प्रकार",
    groups: "समूह",
  },
};

export default translations;
